import { dxtToLocalServerTime } from "@dexteel/mesf-core";
import {
  ColDef,
  ColGroupDef,
  ICellRendererParams,
  ValueGetterParams,
} from "ag-grid-enterprise";
import { EditAndDeleteButtons } from "../../../../../../../shared/data-entries/EditAndDeleteButtons";
import { ManualAutoButton } from "../../../../../../../shared/data-entries/ManualAutoButton";
import { ProcessCodeTag } from "../../../../../../../shared/data-entries/ProcessCodeTag";
import { Probe } from "../../../../models/caster.models";

type Props = {
  deleteProbe: (probeId: number) => void;
  editProbe: (probeId: number) => void;
};

export const useTableData = ({ deleteProbe, editProbe }: Props) => {
  const columns: ColGroupDef[] = [
    {
      headerName: "Probes",
      children: [
        {
          field: "actions",
          headerName: " ",
          flex: 1,
          minWidth: 45,
          cellRenderer: (params: ICellRendererParams<Probe>) => {
            const processCode = params?.data?.ProcessCode;

            if (processCode === "L") {
              return <ProcessCodeTag label="LMF" />;
            }

            return (
              <ManualAutoButton isManual={(params.data as Probe).IsManual} />
            );
          },
        },
        {
          field: "Timestamp",
          headerName: "Time",
          flex: 2,
          valueGetter: (params: ValueGetterParams<Probe>) => {
            if (params?.data?.Timestamp) {
              return dxtToLocalServerTime(params?.data?.Timestamp, "HH:mm");
            }
          },
        },
        {
          field: "Temperature",
          headerName: "Temp",
          valueGetter: (params: ValueGetterParams<Probe>) =>
            params.data?.Temperature?.toFixed(0) || "0",
          flex: 2,
        },
        {
          field: "SuperHeat",
          headerName: "SH",
          valueGetter: (params: ValueGetterParams<Probe>) =>
            params.data?.SuperHeat?.toFixed(0) || "0",
          flex: 2,
        },
        {
          field: "actions",
          headerName: " ",
          flex: 2,
          cellRenderer: (params: ICellRendererParams<Probe>) => {
            const processCode = params?.data?.ProcessCode;

            if (processCode !== "C") {
              return null;
            }

            return (
              <EditAndDeleteButtons
                deleteItem={deleteProbe}
                onEdit={editProbe}
                id={(params.data as Probe).ProbeId}
              />
            );
          },
        },
      ],
    },
  ];

  return { columns };
};
